// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"80898646","239":"f3bdeb11","279":"0cfc2b5e","411":"3a9d01ad","453":"4f9997d1","579":"d2709a9f","615":"b7312cfa","732":"721daaac","913":"cf8387f5","926":"bfcc9bb1"}[chunkId] + ".chunk.js";
};